import { useQuery } from "@tanstack/react-query";
import { monthlyTrainingPlanSummaryApi } from "../../../../../services/human-organization/monthly-training-plan-summary.service";
import { useRequests } from "../../../../../hook";
import { useMemo } from "react";

const users = [
  "thiennv@viags.vn",
  "namdh@viags.vn",
  "trungdt@viags.vn",
  "hieppt@viags.vn",
  "botit@viags.vn",
  "tienhc@viags.vn",
  "huyth@viags.vn",
  "datnt@viags.vn",
  "sonnhong@viags.vn",
  "taidv@viags.vn",
  "thuonghh@viags.vn",
  "luubd@viags.vn",
  "nghitc@viags.vn",
  "phuocvd@viags.vn",
];

const selectHandler = ({ value }: { value: any[] }): any[] => {
  const requests = value.map(monthlyTrainingPlanSummaryApi.toResponse);
  return requests.reverse();
};

export const useMTPSMyRequests = () => {
  const { getMyRequests, getRequests } = useRequests();
  const query = useQuery<any>({
    queryKey: ["MTPS-requests", "me"],
    queryFn: () => monthlyTrainingPlanSummaryApi.getRequests(),
    select: selectHandler,
  });

  const myRequests = useMemo(
    () => getMyRequests(query.data),
    [query.data, getMyRequests]
  );

  const requests = useMemo(
    () => getRequests(query.data, users),
    [query.data, getRequests]
  );

  return { ...query, data: myRequests, requests };
};
